import { useState, useCallback } from 'react'
import Papa from 'papaparse'

/**
 * Custom hook for handling CSV file uploads with Papa Parse
 *
 * @returns {Object} Upload state and handlers
 * @property {Object} file - Current file state { name, data, rawFile }
 * @property {boolean} loading - Upload loading state
 * @property {boolean} hasError - Error state
 * @property {Function} handleUpload - Upload handler function
 * @property {Function} setFile - File state setter
 * @property {Function} setHasError - Error state setter
 * @property {Function} reset - Reset all state
 */
export function useCsvUpload() {
  const [file, setFile] = useState({ name: '', data: null, rawFile: null })
  const [loading, setLoading] = useState(false)
  const [hasError, setHasError] = useState(false)

  const handleUpload = useCallback((uploadedFile) => {
    if (!uploadedFile) {
      return
    }

    const fileName = uploadedFile.name
    setLoading(true)
    setHasError(false)

    Papa.parse(uploadedFile, {
      skipEmptyLines: true,
      complete(results) {
        setFile({ name: fileName, data: results.data, rawFile: uploadedFile })
        setLoading(false)
      },
      error(error) {
        console.error('CSV parsing error:', error)
        setHasError(true)
        setLoading(false)
      },
    })
  }, [])

  const reset = useCallback(() => {
    setFile({ name: '', data: null, rawFile: null })
    setLoading(false)
    setHasError(false)
  }, [])

  return {
    file,
    loading,
    hasError,
    handleUpload,
    setFile,
    setHasError,
    reset,
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useCsvUpload/index.js